import React from 'react';
import PropTypes from 'prop-types';
import { flowRight as compose } from 'lodash';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles';
import ProfileVerifiedView from '../../../components/siteadmin/ProfileVerifiedView';
import Loader from '../../../components/Loader';
import profileViewDetail from './profileView.graphql';
import { withQuery } from '../../../hoc/withGraphql';
import { demoRestrictionEncode } from '../../../helpers/DemoRestriction/demoRestriction';
import s from './ProfileView.css';

class ProfileView extends React.Component {

	static propTypes = {
		title: PropTypes.string.isRequired,
		data: PropTypes.shape({
			loading: PropTypes.bool,
			showUserProfile: PropTypes.array,
		})
	};

	static defaultProps = {
		data: {
			loading: true
		}
	};

	constructor(props) {
		super(props);
		this.state = {
			isRestrict: false,
		};
	}

	async componentDidMount() {
		const { demoRestrictionEncode } = this.props;
		const isRestrict = await demoRestrictionEncode();
		this.setState({ isRestrict });
	}


	render() {
		const { data: { loading, showUserProfile }, profileId } = this.props;
		const { isRestrict } = this.state;

		if (loading) {
			return <Loader type={"text"} />;
		} else {
			return <ProfileVerifiedView
				data={showUserProfile}
				profileId={profileId}
				isRestrict={isRestrict}
			/>;
		}
	}

}

const mapState = state => ({});

const mapDispatch = {
	demoRestrictionEncode
};

export default compose(
	withStyles(s),
	connect(mapState, mapDispatch),
	withQuery(profileViewDetail,
		{
			options: (props) => ({
				variables: {
					profileId: props.profileId,
				},
				fetchPolicy: 'network-only',
				ssr: false
			})
		}),
)(ProfileView);
